import { memo, Suspense, useEffect, useState } from 'react';

import CustomCamera from '0_canvas/CustomCamera/CustomCamera';
import TilesScene from '0_canvas/Scenes/TilesScene/TilesScene';
import Sky from '0_canvas/Sky/Sky';
import { useResponseStore } from 'state/responseStore';
import { publicAssets } from 'utils/gcs';

import WeatherScreenScene from '../WeatherScreenSceene/WeatherScreenScene';

const MainScene = () => {
  const [weatherScreenTextureUrl, setWeatherScreenTextureUrl] = useState('');
  const response = useResponseStore(s => s.response);

  useEffect(() => {
    setWeatherScreenTextureUrl(
      response?.streetview?.imageUrl || publicAssets('/effects/house.jpeg')
    );
  }, [response]);

  return (
    <>
      <TilesScene />
      <CustomCamera />
      <Sky />
      {/*
        WeatherScreenScene loads its texture with useLoader, which suspends
        again whenever textureUrl changes — that happens as soon as the
        response data arrives. Without a boundary of its own the suspension
        would reach past the rest of the scene and blank the globe with it.
      */}
      {weatherScreenTextureUrl && (
        <Suspense fallback={null}>
          <WeatherScreenScene textureUrl={weatherScreenTextureUrl} />
        </Suspense>
      )}
    </>
  );
};

export default memo(MainScene);
